module.exports = __webpack_public_path__ + "img/icon-briefcase.c3f79e9d.svg";